import {UserOverviewComponent} from './user-overview.component';
import {UserFormComponent} from './user-form.component';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {dynamicStateConfigFn, Ng2DynamicStateDeclaration} from '@ngx-ivengi/locale';

export let CHILD_STATES: Ng2DynamicStateDeclaration[] = [
  {
    name: 'user',
    component: UserOverviewComponent,
    future: true,
    data: {
      pageTitle: 'states.user.pageTitle',
      breadcrumbTitle: 'states.user.breadcrumbTitle',
      scopes: ['user:read']
    }
  },
  {
    name: 'user.add',
    component: UserFormComponent,
    future: true,
    data: {
      pageTitle: 'states.user.add.pageTitle',
      scopes: ['user:create']
    }
  },
  {
    name: 'user.edit',
    component: UserFormComponent,
    future: true,
    data: {
      pageTitle: 'states.user.edit.pageTitle',
      scopes: ['user:update']
    }
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: CHILD_STATES,
      config: dynamicStateConfigFn
    }),
    TranslateModule
  ],
  exports: [UIRouterModule]
})
export class UserRoutingModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/user/user.routes.ts